"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterConjunction = exports.FilterDuration = exports.FOperator = exports.ViewType = void 0;
const field_types_1 = require("./field_types");
var ViewType;
(function (ViewType) {
    ViewType["Grid"] = "Grid";
    ViewType["Gallery"] = "Gallery";
    ViewType["Kanban"] = "Kanban";
    ViewType["Gantt"] = "Gantt";
    ViewType["Calendar"] = "Calendar";
    ViewType["Architecture"] = "Architecture";
})(ViewType = exports.ViewType || (exports.ViewType = {}));
var FOperator;
(function (FOperator) {
    FOperator["Is"] = "is";
    FOperator["IsNot"] = "isNot";
    FOperator["Contains"] = "contains";
    FOperator["DoesNotContain"] = "doesNotContain";
    FOperator["IsEmpty"] = "isEmpty";
    FOperator["IsNotEmpty"] = "isNotEmpty";
    FOperator["IsGreater"] = "isGreater";
    FOperator["IsGreaterEqual"] = "isGreaterEqual";
    FOperator["IsLess"] = "isLess";
    FOperator["IsLessEqual"] = "isLessEqual";
    FOperator["IsRepeat"] = "isRepeat";
})(FOperator = exports.FOperator || (exports.FOperator = {}));
var FilterDuration;
(function (FilterDuration) {
    FilterDuration["ExactDate"] = "ExactDate";
    FilterDuration["DateRange"] = "DateRange";
    FilterDuration["Today"] = "Today";
    FilterDuration["Tomorrow"] = "Tomorrow";
    FilterDuration["Yesterday"] = "Yesterday";
    FilterDuration["ThisWeek"] = "ThisWeek";
    FilterDuration["PreviousWeek"] = "PreviousWeek";
    FilterDuration["ThisMonth"] = "ThisMonth";
    FilterDuration["PreviousMonth"] = "PreviousMonth";
    FilterDuration["ThisYear"] = "ThisYear";
    FilterDuration["SomeDayBefore"] = "SomeDayBefore";
    FilterDuration["SomeDayAfter"] = "SomeDayAfter";
    FilterDuration["TheLastWeek"] = "TheLastWeek";
    FilterDuration["TheNextWeek"] = "TheNextWeek";
    FilterDuration["TheLastMonth"] = "TheLastMonth";
    FilterDuration["TheNextMonth"] = "TheNextMonth";
})(FilterDuration = exports.FilterDuration || (exports.FilterDuration = {}));
var FilterConjunction;
(function (FilterConjunction) {
    FilterConjunction["And"] = "and";
    FilterConjunction["Or"] = "or";
})(FilterConjunction = exports.FilterConjunction || (exports.FilterConjunction = {}));
